"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VoucherFormContent = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../hooks");
var _types = require("../../types");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const VoucherFormContent = (param)=>{
    let { error, isVoucherApplied } = param;
    var _errors_voucherCode_message, _errors_voucherCode;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const theme = (0, _mui.useTheme)();
    const { register } = (0, _reactHookForm.useFormContext)();
    const { errors } = (0, _reactHookForm.useFormState)();
    const hasError = Boolean(errors.voucherCode) || Boolean(error);
    var _errors_voucherCode_message_toString;
    const helperText = (_errors_voucherCode_message_toString = (_errors_voucherCode = errors.voucherCode) === null || _errors_voucherCode === void 0 ? void 0 : (_errors_voucherCode_message = _errors_voucherCode.message) === null || _errors_voucherCode_message === void 0 ? void 0 : _errors_voucherCode_message.toString()) !== null && _errors_voucherCode_message_toString !== void 0 ? _errors_voucherCode_message_toString : error;
    const voucherCodeInput = (0, _react.useMemo)(()=>error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ExclamationMark, {
            ...getTestIdProps(_types.TestId.VouchersExclamationMark)
        }) : null, [
        error,
        getTestIdProps
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.TextField, {
                fullWidth: true,
                ...register('voucherCode'),
                variant: "outlined",
                id: "voucherCode",
                name: "voucherCode",
                error: hasError,
                helperText: helperText,
                label: formatMessage('voucherCode'),
                placeholder: formatMessage('addCodeHere'),
                FormHelperTextProps: {
                    component: _styles.HelperTextWrapper
                },
                InputProps: {
                    endAdornment: voucherCodeInput
                },
                ...getTestIdProps(_types.TestId.VouchersInput)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                fullWidth: true,
                type: "submit",
                variant: "contained",
                color: "primary",
                disabled: Boolean(errors.voucherCode),
                ...getTestIdProps(_types.TestId.AddVoucherButton),
                startIcon: isVoucherApplied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.CheckHeavy, {}) : null,
                sx: {
                    marginTop: theme.spacing(6)
                },
                children: isVoucherApplied ? formatMessage('applied') : formatMessage('add')
            })
        ]
    });
};
exports.VoucherFormContent = VoucherFormContent;
